import { render, staticRenderFns } from "./MoreDetail.vue?vue&type=template&id=0fd3a64e&scoped=true"
import script from "./MoreDetail.vue?vue&type=script&lang=js"
export * from "./MoreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3a64e",
  null
  
)

export default component.exports